import { useQuery } from "react-query"
import { get_companies } from "../../services/approvals";


const useCompanies = (page, filter, name_pattern, sort_by) => {
    return useQuery(['get_companies', page, filter, name_pattern, sort_by], ()=>get_companies(page, filter, name_pattern, sort_by))
}

export default useCompanies;